import { EditorAPIKey, EditorCoreApiKey } from '@/apis';
import { BaseEntryScope } from '@/apilib';

export class Scope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
}
